<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            <i class="las" :class="$router.currentRoute.meta.icon"></i>
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>
                      
                    <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">

                        <div class="row margin-top-20">
                            <div class="col-xl-12 margin-bottom-20">
                                <p class="help">
                                    <i class="las la-question-circle"></i>
                                    Gerencie abaixo as configurações globais do sistema.
                                </p>
                            </div>  
                            <div class="col-xs-12 col-xl-12">
                                <div class="row">

                                    <div class="col-xs-12 col-xl-4">
                                        <div class="submit-field margin-bottom-20">
                                            <h5>
                                                Local de origem (planejamento):
                                            </h5>
                                            <input type="text" class="with-border" placeholder="Informe o nome" v-model="form.origemNome">
                                        </div>
                                    </div>

                                    <div class="col-xs-12 col-xl-4">
                                        <div class="submit-field margin-bottom-20">
                                            <h5>
                                                Latitude de origem (planejamento):
                                            </h5>
                                            <input type="text" class="with-border" placeholder="..." v-model="form.origemLatitude">
                                        </div>
                                    </div>

                                    <div class="col-xs-12 col-xl-4">
                                        <div class="submit-field margin-bottom-20">
                                            <h5>
                                                Longitude de origem (planejamento):
                                            </h5>
                                            <input type="text" class="with-border" placeholder="..." v-model="form.origemLongitude">
                                        </div>
                                    </div>                                                                        

                                    <div class="col-xs-12" v-bind:class="{'disabled': $root.user.id != 1}">
                                        <div class="submit-field">
                                            <h5>
                                                <i class="las la-file-contract"></i>
                                                Texto do contrato padrão
                                                <b class="opcional-obrigatorio">(obrigatório)</b>
                                            </h5>
                                            <trumbowyg v-model="form.contratoPadrao" :config="config" class="" name="conteudo"></trumbowyg>
                                            
                                        </div>
                                    </div>

                                    <div class="col-xl-12 margin-bottom-30 margin-top-50">
                                        <button type="submit" class="button color-green block-mobile">
                                            <i class="las la-save"></i>
                                            Salvar informações
                                        </button>                                                     
                                    </div>
                                </div>
                            </div>
                        </div>
                          
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'
import AvatarCropper from "vue-avatar-cropper"

export default {
    name: 'Configuracoes',
    components: {
        'Trumbowyg':        VueTrumbowyg.default,
        'Top':              Top,
        'Sidebar':          Sidebar,
        'Toolbar':          Toolbar,
        'AvatarCropper':    AvatarCropper
    },    
    filters: {
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },         
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }

            return date + (time ? (" " + time) : "");
        }
    },       
    data () {
        var self                    = this;
        return {
            config: {
                svgPath:            "https://cdnjs.cloudflare.com/ajax/libs/Trumbowyg/2.20.0/ui/icons.svg",
                btns: [
                    ['undo', 'redo'],
                    ['formatting'],
                    ['viewHTML'],
                    ['fontsize'],
                    ['strong', 'em', 'del'],
                    ['link'],
                    // ['insertImage'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                    ['unorderedList', 'orderedList'],
                    ['horizontalRule'],
                    ['removeformat'],
                    // ['fullscreen']
                ]
            },              
            "loading": {
                "submit":           false
            },
            "categorias": {
                "itens":            []
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "contratoPadrao":   ""
                
            }            
        }
    },
    methods: {       
        submit: function(e) {
            var self            = this;
           
            console.log("submit", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            loading.show("Salvando informações..");
                
            self.form._cod      = self.$root.user.cod;
            self.form._token    = self.$root.user.token;

            axios.put("api/configuracoes.php", self.form)
            .then(response => {
                console.log("ok", response.data.result)                        
                self.salvo          = true;
                loading.hide();
                $(".dashboard-content-inner")[0].scrollTo({
                    top: 5
                });                   
                alert(response.data.message);
                // self.$root.go("Dashboard");   
            })
            .catch(error => {
                loading.hide();
                alert(error.response.data.message || "Erro! Por favor, tente novamente.");
            });

        },       
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token
                    }
                };

                axios.get("api/configuracoes.php", form)
                .then(response => {
                    
                    console.log("get() response", response);

                    self.form           = response.data.result;
                    self.loaded         = true;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        }          
    },
    created: function() {
    },
    mounted: function() {
        var self = this;
        loading.show();
        self.get();
    
    },
    beforeRouteLeave (to, from, next) {
        var self = this;
        if (!self.salvo) {
            const answer = window.confirmWeb('Você tem certeza que deseja sair da página atual? Modificações não salvas podem ser perdidas.')
            if (!answer) return false;
        }
        next();
    }         
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Configuracoes.vue